/* eslint-disable ta-code-conventions/has-matching-test */
// This component is mostly pass-through, so disable the test
// @flow
import * as React from 'react';
import UploaderActionButton from './UploaderActionButton';
import Positioner from './Positioner';
import type { UgcAction } from './UgcActionMapper';

import styles from './SocialFab.less';

/** Props exposed to consumers of the component */
type Props = {|
  actions: UgcAction[],
  /** A callback that fires whenever the primary button is clicked. */
  onClick?: (SyntheticEvent<*>) => mixed,
  /** A callback that fires in the event where we transition to and from the uploading view */
  onChange?: (show: boolean) => mixed,
  /** The pixel offset to display the FAB from the bottom */
  bottom: number,
  /** The pixel offset to display the FAB from the right */
  right: number,
|};

const SocialFab = ({ actions, onClick, onChange, bottom, right }: Props) => (
  <Positioner bottom={bottom} right={right}>
    {position => (
      <UploaderActionButton
        actions={actions}
        onClick={onClick}
        onChange={onChange}
        className={styles.overlay}
        style={position}
      />
    )}
  </Positioner>
);

SocialFab.defaultProps = {
  actions: [],
  onClick: undefined,
  onChange: undefined,
  bottom: 12,
  right: 8,
};

export default SocialFab;
